import ResetPassword from '@/Component/Auth/Resetpassword';
import { Metadata } from 'next';

export const metadata: Metadata = {
    title: "Reset Password | Connector Club",
    description: "",
};

const ResetPasswordPage = () => {
  return (
    <ResetPassword />
  )
}

export default ResetPasswordPage
